<template>
  <div class="layout-px-spacing">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page"><span>{{ $t('Profile') }}</span></li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12">
        <div class="d-flex align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-arrow-left" data-v-02c2cbc4="">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <router-link class="text-primary" tag="a" :to="{ name: 'Dashboard' }">{{ $t('Back') }}</router-link>
        </div>
      </div>
    </div>
    <div class="row layout-top-spacing">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
        <div class="panel br-4">
          <div class="panel-body">
            <form>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="name">{{ $t('Name') }}</label>
                <div class="col-sm-10">
                  <input type="text" id="name" class="form-control" v-model="formData.name"
                    :class="[hasFormError.name ? (hasFormError.name ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Name')"
                    @blur="userClientStore.removeErrorFormSingle('name')" />
                  <div v-if="hasFormError.name" class="invalid-feedback">{{ hasFormError.name }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="phone">{{ $t('Phone') }}</label>
                <div class="col-sm-10">
                  <input type="text" id="phone" class="form-control" v-model="formData.phone"
                    :class="[hasFormError.phone ? (hasFormError.phone ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Phone')"
                    @blur="userClientStore.removeErrorFormSingle('phone')" />
                  <div v-if="hasFormError.phone" class="invalid-feedback">{{ hasFormError.phone }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="email">{{ $t('Email') }}</label>
                <div class="col-sm-10">
                  <input type="text" id="email" class="form-control" v-model="formData.email"
                    :class="[hasFormError.email ? (hasFormError.email ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Email')"
                    @blur="userClientStore.removeErrorFormSingle('email')" />
                  <div v-if="hasFormError.email" class="invalid-feedback">{{ hasFormError.email }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="username">{{ $t('Username') }}</label>
                <div class="col-sm-10">
                  <input type="text" id="username" class="form-control" v-model="formData.username"
                    :class="[hasFormError.username ? (hasFormError.username ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Username')"
                    @blur="userClientStore.removeErrorFormSingle('username')" />
                  <div v-if="hasFormError.username" class="invalid-feedback">{{ hasFormError.username }}</div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useUserSystemStore } from '@/store/setting/userSystemStore';
import { storeToRefs } from 'pinia';

const userSystemStore = useUserSystemStore();
userSystemStore.resetForm();
const { formData, hasFormError } = storeToRefs(userSystemStore);
userSystemStore.getUserLogin();
</script>
